import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Partner, PartnersList } from '../models/partner';
import { CategoriesList, Category } from '../models/category';
import { PartnerDetails } from '../models/partnerDetails';

@Injectable({
  providedIn: 'root'
})
export class PartnerService extends BaseService {
  apiUrl = '/api/wallet/';
  constructor(private httpClient: HttpClient) {
    super();
  }
  getAll() {
    return this.httpClient.get<PartnersList>(
      this.baseUrl + this.apiUrl + 'GetMerchantsList',
      this.getAuthHeader()
    );
  }
  getCategories() {
    return this.httpClient.get<CategoriesList>(
      this.baseUrl + this.apiUrl + 'GetCategoriesList',
      this.getAuthHeader()
    );
  }
  getPartnerById(id: number, categoryId: number, getRelated: boolean) {
    return this.httpClient.get<PartnerDetails>(
      this.baseUrl +
        this.apiUrl +
        'getPartnerById?id=' +
        id +
        '&categoryId=' +
        categoryId +
        '&getRelated=' +
        getRelated,
      this.getAuthHeader()
    );
  }
}
